import { createContext, useContext } from "react";

const Context = createContext<{
  brand: "yandex" | "yango";
}>({ brand: "yandex" });

export const BrandProvider = Context.Provider;

export const useBrand = () => useContext(Context);
